module.exports = __webpack_public_path__ + "static/img/product_household_first_aid_kit.1f4fefa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/firstaidkit/product_household_first_aid_kit.png
// module id = MKEb
// module chunks = 1